import React from 'react';
import { Spinner } from '../globals';
import { HasNextPage, NextPageButton } from './style';
import VisibilitySensor from 'react-visibility-sensor';
import { Link } from 'react-router-dom';

const NextPageButtonWrapper = props => {
  const {
    isFetchingMore,
    fetchMore,
    href,
    children,
    automatic = true,
    topOffset = -250,
    bottomOffset = -250,
    updateQuery,
    previousData,
    setlistData,
    setHasNextPage,
    listData,
  } = props;

  const [pageData, setPageData] = React.useState({ data: {} });
  const [after, setAfter] = React.useState('');
  React.useEffect(() => {
    const { data } = pageData;
    if (
      data?.threads?.threadsConnection &&
      setHasNextPage &&
      setlistData &&
      listData
    ) {
      const { edges, pageInfo } = data?.threads?.threadsConnection;
      const { hasNextPage } = pageInfo;
      if (edges.length === 0) {
        setHasNextPage(false);
        return;
      }
      if (
        edges[edges.length - 1].cursor !== listData[listData.length - 1].cursor
      ) {
        setlistData([...listData, ...edges]);
        setHasNextPage(hasNextPage);
      }
      setAfter(edges[edges.length - 1].cursor);
    }
  }, [pageData]);

  const onChange = async isVisible => {
    if (!isFetchingMore && isVisible && fetchMore) {
      let fetchParams = '';
      if (updateQuery) {
        fetchParams = { updateQuery };
        const { threads } = previousData;
        if (threads) {
          fetchParams = {
            ...fetchParams,
            variables: { after },
          };
        }
      }
      const result = fetchParams ? await fetchMore(fetchParams) : fetchMore();
      if (setlistData) {
        setPageData(result);
      }
    }
  };
  return (
    <HasNextPage
      as={href ? Link : 'div'}
      to={href}
      onClick={e => {
        e.preventDefault();
        onChange(true);
      }}
      data-cy="load-previous-messages"
    >
      <VisibilitySensor
        active={automatic !== false && !isFetchingMore}
        delayedCall
        partialVisibility
        scrollCheck
        intervalDelay={150}
        onChange={onChange}
        offset={{
          top: topOffset,
          bottom: bottomOffset,
        }}
      >
        <NextPageButton loading={isFetchingMore}>
          {isFetchingMore ? (
            <Spinner size={16} color={'brand.default'} />
          ) : (
            children || 'Load more'
          )}
        </NextPageButton>
      </VisibilitySensor>
    </HasNextPage>
  );
};

export default NextPageButtonWrapper;
